import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FooterTendanceActivePictoProps extends pictoProps {
}

export interface FooterTendanceActivePictoState extends pictoState {
}

export class FooterTendanceActivePicto extends Picto<FooterTendanceActivePictoProps,FooterTendanceActivePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerTendanceActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterTendanceActivePicto);
